import { Card, Grid, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import { ArrowForwardIosRounded, LocalLibraryRounded, SchoolRounded, CastForEducationRounded } from '@material-ui/icons';
import DropDown from './DropDown';
  
export default class CompetencyQuestion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            score: null,
            answered: false,
        }
        this.drop_down_child_ref = React.createRef();
    }
    
    handleSelectUpdate = (e) => {
        // console.log('e :>> ', e);
        if (!e.value) {
            this.setState({score: null, answered: false});
            this.props.updateScore({competency_id: this.props.competency.competency_id, competency: this.props.competency.competency, area: this.props.competency.area, division: this.props.competency.division, score: null, answered:false});
        } else {
            this.setState({score: e.value, answered: true});
            this.props.updateScore({competency_id: this.props.competency.competency_id, competency: this.props.competency.competency, area: this.props.competency.area, division: this.props.competency.division, score: e.value, answered:true});
        }
    }

    resetMe = () => {
        this.drop_down_child_ref.current.resetMe();
        this.setState({score: null, answered: false});
    }

    render() {
    const comp = this.props.competency;        
    return (
    <div>
        <Grid
            container
            direction='row'
            alignContent='center'
            justifyContent='flex-start'
            style={{width:'1050px'}}
        >
            &nbsp;&nbsp;
            <Card
                elevation={2}
                style={{padding:'10px', width:'700px'}}
            >
                <Typography
                    style={{textAlign:'left'}}
                >
                    Area: <b>{comp.area}</b><br/> {comp.competency} 
                </Typography>
            </Card>

            <ArrowForwardIosRounded
                fontSize='large'
                style={{alignSelf:'center'}}
            />
            &nbsp;&nbsp;
                
            <DropDown 
                fieldMap={{
                    field: "comp_score",
                    headerName: "Assessed Competency",
                    f_inputType:'dropdown',
                    f_show:true,
                    f_required:true}}
                setField={this.handleSelectUpdate}
                editRecord={null}
                listArray={[
                    {score:0,rating: 'Not Yet Competent'},
                    {score:1,rating: 'Competent'},
                    {score:2,rating: 'Expert (can teach others)'}
                ]}
                // disabled={this.state.creating_nomination}
                fullwidth={false}
                ref={this.drop_down_child_ref}
            />
            &nbsp;&nbsp;
            {/* Iconography to go here... */}

            {this.state.answered&&this.state.score==='0'&&
            <LocalLibraryRounded 
                color='action'
                fontSize='large'
                style={{marginTop:'auto',marginBottom:'auto'}}
            />}

            {this.state.answered&&this.state.score==='1'&&
            <SchoolRounded 
                color='primary'
                fontSize='large'
                style={{marginTop:'auto',marginBottom:'auto'}}
            />}

            {this.state.answered&&this.state.score==='2'&&
            <CastForEducationRounded
                color='primary'
                fontSize='large'
                style={{marginTop:'auto',marginBottom:'auto'}}
            />}

        </Grid>
    <hr style={{width:'100%'}}/>
    </div>

    );}
}